(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsFilterBarFreeTextSearch', rmsFilterBarFreeTextSearch);

    function rmsFilterBarFreeTextSearch() {
        return {
            restrict: 'E',
            scope: {},
            controller: rmsFilterBarFreeTextSearchCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/filter-bar/tools/free-text-search'
        };
    }

    function rmsFilterBarFreeTextSearchCtrl($scope, MainFilterBarService) {
        var vm = this;
        this.$onInit = function() {
            vm.filterBarIdentifier = $scope.$parent.vm.filterBarIdentifier;
            MainFilterBarService.sync(vm, vm.filterBarIdentifier); // this gives vm.filterBarService();

            vm.submit = submit;
            vm.onChange = onChange;

            init();
        }

        function init() {
            vm.state = vm.filterBarService().getState();
            vm.showInput = vm.filterBarService().hasType('search');
            vm.options = vm.filterBarService().getOptions('search');
            if (!vm.options.search_on_change) {
                if (vm.options.use_icon) {
                    vm.buttonLabel = `<i class="fa ${vm.options.icon}"></i>`;
                } else {
                    vm.buttonLabel = `${vm.filterBarService().getMessageLabel('search')}`;
                }
            }
        }

        function submit() {
            vm.filterBarService().applySearch();
        }

        function onChange() {
            if (vm.options.search_on_change) {
                submit();
            }
        }

    }
})();